import { AnalyticsID } from 'lib/analytics/constants';
import type { PolarAnalytics } from 'lib/analytics/polar';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

import { useAnalyticsDelegatorStore } from './useAnalyticsStore';
import { usePolarLandingPageView } from './usePolarLandingPageView';

export const usePolarIdentity = () => {
  const { data } = useSession();
  const analyticsDelegator = useAnalyticsDelegatorStore(
    (s) => s.analyticsDelegator,
  );
  const sinksRegistered = useAnalyticsDelegatorStore((s) => s.sinksRegistered);
  const email = data?.user?.email ?? undefined;

  useEffect(() => {
    if (!sinksRegistered) return;

    analyticsDelegator
      .getSink<PolarAnalytics>(AnalyticsID.PolarSdk)
      ?.setCustomer(email ? { email } : undefined);
  }, [analyticsDelegator, sinksRegistered, email]);
};

export const PolarSdkSession = () => {
  usePolarIdentity();
  usePolarLandingPageView();
  return null;
};
